import { Mail, Handshake, ScrollText } from "lucide-react";

/**
 * "Comment ça se passe ensuite ?" — 3 étapes affichées sur la fiche annonce.
 */
export default function NextStepsBlock() {
  const steps = [
    { icon: Mail, label: "Contact", text: "Vous recevez le dossier complet, échangez avec le vendeur ou l’agence en charge, et posez toutes vos questions." },
    { icon: Handshake, label: "Accord", text: "Vous convenez ensemble du bouquet, de la durée et des mensualités. L’accord se formalise par une offre écrite." },
    { icon: ScrollText, label: "Notaire", text: "Signature de l’acte authentique. Hypothèque légale spéciale + clause résolutoire inscrites. Vous devenez propriétaire." },
  ];
  return (
    <div data-testid="next-steps-block" className="border-t border-navy/10 pt-8 mt-8">
      <h3 className="font-serif text-xl text-navy mb-6 text-balance">Comment ça se passe ensuite&nbsp;?</h3>
      <ol className="grid sm:grid-cols-3 gap-4">
        {steps.map(({ icon: Icon, label, text }, i) => (
          <li key={i} className="relative bg-cream border border-navy/10 p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 border border-accent-brand/40 bg-accent-brand/5 flex items-center justify-center">
                <Icon size={18} className="text-accent-brand" strokeWidth={1.5} />
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-navy/50 font-bold">Étape&nbsp;{i + 1}</div>
            </div>
            <div className="font-serif text-lg text-navy mb-1">{label}</div>
            <p className="text-sm text-navy/70 leading-relaxed">{text}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
